const data: string = "<div id=\"acp-family-cards-section\" layout=\"row\" layout-align=\"center\" layout-margin><acp-family-cards-intro component-name=\"$resolve.$componentName\"></acp-family-cards-intro></div>";
export default data